import { createSlice, isAnyOf } from "@reduxjs/toolkit";
// eslint-disable-next-line import/no-extraneous-dependencies
import Cookies from "js-cookie";
import { addToState, isFulfilledAction, isPendingAction, isRejectedAction } from "../../utilities";
import { getCurrentUser, getUserById, getUsers, getFilteredUsers, patchUser, deleteUser, uploadDocument } from "./actions";
import { patchPromoter } from "../referrals/actions";

const initialState = {
  loading: false,
  data: null,
  filteredUsers: [],
  totalFiltered: 0,
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.fulfilled, (state, { payload }) => ({
        ...state,
        data: payload,
      }))

      .addCase(getFilteredUsers.fulfilled, (state, { payload }) => {
        Cookies.remove("applyFilter");

        return {
          ...state,
          filteredUsers: payload?.content || [],
          totalFiltered: payload?.totalElements || 0,
        };
      })

      .addCase(patchPromoter.fulfilled, (state, { payload }) => ({
        ...state,
        data: (state.data || []).map((i) => {
          if (i.id === payload.userId) {
            return { ...i, promoter: payload };
          }
          return i;
        }),
      }))

      .addCase(deleteUser.fulfilled, (state, { meta }) => ({
        ...state,
        data: (state.data || []).filter((user) => user.id !== meta.arg),
      }))

      .addCase(uploadDocument.fulfilled, (state, { payload }) => ({
        ...state,
        data: state.data.map((user) => {
          if (user.id === payload.userId) {
            return {
              ...user,
              remainingDocuments: user.remainingDocuments.filter((doc) => doc.name !== payload.documentType),
            };
          }
          return user;
        }),
      }))

      .addMatcher(isAnyOf(getCurrentUser.fulfilled, patchUser.fulfilled, getUserById.fulfilled), (state, { payload }) => ({
        ...state,
        data: addToState(payload, state.data),
      }))

      .addMatcher(isPendingAction("users"), (state) => ({
        ...state,
        loading: true,
      }))

      .addMatcher(isRejectedAction("users"), (state) => ({
        ...state,
        loading: false,
      }))

      .addMatcher(isFulfilledAction("users"), (state) => ({
        ...state,
        loading: false,
      }));
  },
});

export default usersSlice.reducer;
